import React from 'react';
import {Password} from 'primereact/password';

interface CenteredInputPasswordProps {
  id: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  label: string;
  icon: string;
  required?: boolean;
  feedback?: boolean;
  helpText?: string;
}

const CenteredInputPassword: React.FC<CenteredInputPasswordProps> = ({
  id,
  name,
  value,
  onChange,
  placeholder,
  label,
  icon,
  required = false,
  feedback = false,
  helpText
}) => {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      <div className="relative">
        <Password
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          feedback={feedback}
          required={required}
          className="w-full border border-gray-300 rounded-sm"
          pt={{
            input: {className: 'w-full px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:border-transparent transition duration-300'}
          }}
        />
        <i className={`absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 ${icon}`}/>
      </div>
      {helpText && (
        <p className="text-xs text-gray-500 mt-1">{helpText}</p>
      )}
    </div>
  );
};

export default CenteredInputPassword;
